"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatsAndTiesSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const zod_1 = require("zod");
exports.FloatsAndTiesSchema = zod_1.default.record(zod_1.default.string(), zod_1.default.object({
    floatingBehavior: zod_1.default.nativeEnum(sigma_engine_shared_1.SignalFloatingBehavior).optional(),
    ties: sigma_engine_shared_1.IExternalComponentSchema.array().optional(),
}));
//# sourceMappingURL=extract-floats-and-ties.types.js.map